import { Component, Inject, OnInit } from '@angular/core';

import { Paginacao } from '@app/models/util/paginacao';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { PeticaoArea } from '@app/models/peticao-area.model';
import { PeticaoAreaService } from '@app/services/peticao-area.service';
import { ToastrService } from 'ngx-toastr';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';

@Component({
  selector: 'app-peticao-areas-lista',
  templateUrl: './peticao-areas-lista.component.html'
})
export class PeticaoAreasListaComponent implements OnInit {

  paginacao: Paginacao = new Paginacao();
  lstArea: Area[];
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private peticaoAreaService: PeticaoAreaService,
    private modalService: BsModalService,
    private areaService: AreaService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.areaService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstArea = data,
        this.paginacao.totalDeItens = data.length;
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(peticaoArea: PeticaoArea) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a área: " + peticaoArea.Descricao;
    this.bsModalRef.content.confirmar = () => {
      this.peticaoAreaService.deletar(peticaoArea.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
